/**
 * Fxxl Device
 *
 * Filename: fxxl_device.ts
 *
 * @category  Fahrradxxl
 * @author    Janik Kemnade <j.kemnade@fahrrad-xxl.de>
 * @copyright 2026 Fahrrad-xxl.de
 */



/* 📜 INFORMATION
 * --------------------------------------------------------------------------------------------------------------------
 * ACHTUNG: WIP
 * Dies ist eine vorgebaute Datei die uns ermöglichen soll zentralisiert
 * über die Klassen FxxlDevice und dessen statischen Methoden Browser, sowie Geräte-Daten
 * einer User Session detailliert zu erfassem.
 *
 * Aktuell finden sich verschiedene Handlings verstreut in der Code-Basis, die meisten Erfassungs-Funktionen
 * finden sich in der 400_functions_and_variables.js.
 *
 * Usage:
 * - dev/customer_fahrradxxl/custom/module/public/fxxl3/assets/js/module/fxxl_print.ts -> print()
 *
 * Beispiele für Weiterentwicklung: custom/module/public/fxxl3/assets/js/README-fxxl_device.md
 */






/* 📦️ IMPORTS
 * ----------------------------------------------------------------------------------------------------------------- */






/* ✒️ CLASS: FxxlDeviceBrowser
 * ----------------------------------------------------------------------------------------------------------------- */
export class FxxlDeviceBrowser {

    /* 🌐️ GET: Safari
     * ----------------------------------------------------------------------------------------- */
    public static isSafari(): boolean {
        const ua: string = navigator.userAgent || '';

        return (
            /Safari/i.test(ua)
            && !/Chrome|Chromium|CriOS|Edg|OPR|Firefox|FxiOS/i.test(ua)
        );
    }
}